module.exports = __webpack_public_path__ + "static/media/en.602993cf.png";